import React from 'react';
import { withTranslation, useTranslation } from 'react-i18next';
import './aiComments';
import './../sidePanel.scss';
import ImgIconComp from '../../../../components/imgcomp';
import GoalServices from "../../../../services/goal.services";
import { type WithTranslation } from '../../../types/common.types';
import { AiAttachmentProps } from '../../../types/sidePanel.types';
import { generateSASAnduploadToTempLocation, WoboFileUploadService} from '../../../../services/fileupload.service';
import { v4 as uuidv4 } from 'uuid';

const services = new GoalServices();

export default withTranslation()(class AiAttachmentsComp extends React.Component<WithTranslation<AiAttachmentProps>> {
  public refs: {
    wsBoardAddAttach: HTMLInputElement;
  };
  constructor(props: WithTranslation<AiAttachmentProps>) {
    super(props);
    this.uploadFile = this.uploadFile.bind(this);
  }

  updateFile = (signature, delayMs) => {
    const _this = this;
    var clearTimer = setInterval(async () => {
      services
        .getFileStatus({ signature })
        .then((response) => {
          const jsonData = response?.data
          if (jsonData) {
            if (
              jsonData?.resp?.fus_type == 1 &&
              jsonData?.resp?.fus_status == 1 &&
              jsonData?.resp?.path
            ) {
              clearInterval(clearTimer)
              _this.props.updateAttachState(jsonData.resp);
            }
          }
        })
        .catch((err) => {})
    }, delayMs)
  }

  uploadFile() {
    const _this = this;
    const {isFUSEnabled, loggedInUserId, orgId, appinID, accessToken, t} = _this.props;
    if (_this.refs.wsBoardAddAttach.files) {
      showLoaderWidget();
      $.each(_this.refs.wsBoardAddAttach.files, (k, v) => {
        const file = _this.refs.wsBoardAddAttach.files[k];
        const actId = _this.props.aiDet.id;
        const s3_data:any = _this.props.s3Data;
        const prefix = s3_data.prefix;
        const fileName = replaceSpcicalCharacter(file.name);
        const fileSize = file.size;
        const maxUploadSize = _this.props.upload_max_size
          ? parseInt(_this.props.upload_max_size)
          : 0;

        if (fileSize > maxUploadSize) {
          alert(t(`The file you have uploaded exceeds the maximum size of {{size}}MB.`, { size: _this.props.upload_max_size_configured }));
          removeLoaderWidget();
          return;
        }
        if (
          file.type == "application/x-msdownload" ||
          file.type == "text/mspg-legacyinfo" ||
          file.type == "application/x-ole-storage" ||
          file.type == "application/java" ||
          file.type == "application/octet-stream"
        ) {
          alert(t("The file type you have uploaded is not supported."));
          removeLoaderWidget();
          return;
        }

        const callUpload = function() {
          const url = `${wbConfig.baseUrl}/activity/aiAddAttachment`;
          if (isFUSEnabled) {
            let request_id = uuidv4();
            let targetFolderName = uuidv4();
            generateSASAnduploadToTempLocation(file, {
              appinID,
              request_id,
              accessToken,
              userId: loggedInUserId,
              orgId,
            }).then((newFilename) => {
              if (newFilename) {
                const fileName = createFilename(file.name)
                const prefix = `FUS_${request_id}`;
                const params = {
                  fileName,
                  fileSize,
                  prefix,
                  act_id: actId,
                  s3DirectUpload: 2,
                  wsBoardView: true,
                  fus_type: 1,
                  fus_status: 2
                };
                $.ajax({
                  url: `${url}`,
                  type: 'POST',
                  data: params,
                  dataType: 'json',
                  async: true,
                })
                  .done((response) => {
                    const fileObj = {
                      source_fileName: newFilename,
                      file_mimetype: file.type,
                      file_size: file.size,
                      request_id: request_id,
                      signature: prefix,
                      appInID: appinID,
                      byok_tenant_id: "", // this is the tenant id for encrypting the file with
                      file_originalname: fileName, // Name of the file
                      webhook_details: {
                        // "host": `http://host.docker.internal:80/wb/fus/fusCallback?type=1`,
                        "host": `${wbConfig.baseDomainUrl}/fus/fusCallback?type=1`,
                        "path": "",
                      },
                      orgId: orgId, // Organization id
                      userId: loggedInUserId, // User id of the requested user
                      target_folder: targetFolderName, // Name of the target folder inside the target container,
                    }
                    //update list with file name and text 'processing'
                    removeLoaderWidget();
                    _this.props.addAttachToStateList(response.data, response.s3Data);
                    
                    WoboFileUploadService.processFile(fileObj).then(() => {
                      _this.updateFile(prefix, 15000);
                    }).catch((err) => {
                      _this.props.removeItemFromList(
                        "aiAttachments",
                        response.data.id,
                        _this.props.ownerAccess
                      )
                    })
                  })
                  .fail(() => {
                    console.error(`Something went wrong, please try again later.`);
                  })
              }
            })
          } else {
            const params = {
              fileName,
              fileSize,
              prefix,
              act_id: actId,
              s3DirectUpload: 1,
              wsBoardView: true
            };
            if (typeof s3_data.encrypt_type !== 'undefined' && s3_data.encrypt_type === 'azure:sse') {
              // upload file to Azure file storage
              uploadFileToAzureStorage(s3_data.asc, `${prefix}/original/${fileName}`, file)
              .then(result => {
                params.s3DirectUpload = 2;
                $.ajax({
                  url: `${url}`,
                  type: 'POST',
                  dataType: 'json',
                  async: false,
                  data: params
                })
                .done(data => {
                  removeLoaderWidget();
                  if (data && data.status === 'success') {
                    _this.props.addAttachToStateList(data.data, data.s3Data);
                  } else {
                    alert(t('Unable to attach the file, please try again'));
                  }
                })
                .fail((xhr, ajaxOptions, thrownError) => {
                  removeLoaderWidget();
                  alert(t('Error while uploading the file, please try again'));
                });
              });
            } else {
              // upload file to AWS S3 bucket
              uploadSignedFileToS3Storage({resp: s3_data, file})
              .then(result => {
                $.ajax({
                  url: `${url}`,
                  type: 'POST',
                  dataType: 'json',
                  async: false,
                  data: params
                })
                .done(data => {
                  //removeLoaderWidget();
                  if (data && data.status === 'success') {
                    _this.props.addAttachToStateList(data.data, data.s3Data);
                  } else {
                    alert(t('Unable to attach the file, please try again'));
                  }
                })
                .fail((xhr, ajaxOptions, thrownError) => {
                  //removeLoaderWidget();
                  alert(t('Error while uploading the file, please try again'));
                });
              });
            }
          }
        }

        if (window.FileReader && window.Blob) {
          const filereader = new FileReader();
          filereader.onloadend = function(evt: any) {
            if (evt.target.readyState === FileReader.DONE) {
              const uint = new Uint8Array(evt.target.result);
              const bytes = [];
              $.each(uint, (i, byte) => {
                bytes.push(byte.toString(16));
              });
              const hex = bytes.join("").toUpperCase();
              if (hex == "4D5A900" || hex == "4D5A5000" || hex == "FE49BCB") {
                alert(t("The file type you have uploaded is not supported."));
                removeLoaderWidget();
                return;
              }
              callUpload();
            }
          };
          const blob = file.slice(0, 4);
          filereader.readAsArrayBuffer(blob);
        } else {
          callUpload();
        }

        const kVal = k + 1;
        if (_this.refs.wsBoardAddAttach.files.length == kVal) {
          removeLoaderWidget();
        }
      });
    }
  }

  render() {
    const {isFUSEnabled, loggedInUserId, orgId, appinID, accessToken, t} = this.props;
    return (
      <div className="wsBoardAiAttachmentsWrapper">
        <div className="wsBoardAddAttachDiv">
          <div className=" wsBoardAttachIconDiv">
            <input
              id="wsBoardAddAttachInp"
              ref="wsBoardAddAttach"
              type="file"
              className="wsBoardFileInp"
              onChange={this.uploadFile}
              multiple
            />
            <label htmlFor="wsBoardAddAttachInp" className="clickable">
              <div className="displayInlineB vAlignM">
                <ImgIconComp id="addAttach" width="20" height="auto" />
              </div>
              <div className="displayInlineB pL10">{t('Add attachment')}</div>
            </label>
          </div>
        </div>
        <div className="wsBoardAttachListDiv">
          {this.props.aiAttachments != null &&
            Object.keys(this.props.aiAttachments).length
            ? Object.keys(this.props.aiAttachments).map((item: any, index) => (
              <WsBoardAttachListComp
                key={this.props.aiAttachments[item].id}
                attachDet={this.props.aiAttachments[item]}
                removeItemFromList={this.props.removeItemFromList}
                ownerAccess={this.props.ownerAccess}
                isNoAttachmentDownload={this.props.isNoAttachmentDownload}
                isFUSEnabled={isFUSEnabled} loggedInUserId={loggedInUserId}
                orgId={orgId} appinID={appinID} accessToken={accessToken} 
              />
            ))
            : ""}
        </div>
      </div>
    );
  }
});

const RenderFileName = function (props: {fusType: string, fusStatus: string, path: string, 
    attach_name: string, isNoAttachmentDownload: any}) {
  const { t } = useTranslation();
      
  const handleDownload = (path, orgFileName) => {
    const link = document.createElement('a');
    WoboFileUploadService.download(path).then(async (res)=>{
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(new Blob([blob]));
        link.href = blobUrl;
        link.target = "_blank";
        link.setAttribute(
            "download",
            orgFileName
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
  }
  
  if (props.fusType == '1') {
      if (props.fusStatus == '1') {
          return <div className="displayCell wsBoardAttachName" onClick={() => handleDownload(props.path, props.attach_name)}>{props.attach_name}</div>
      } else if (props.fusStatus == '2') {
          return <div className="displayCell wsBoardAttachName">{props.attach_name} {t('(processing)')}</div>
      } else if (props.fusStatus == '5') {
          return <div className="displayCell wsBoardAttachName">{props.attach_name} {t('(infected file, deleted)')}</div>
      }
  } else {
    if (props.isNoAttachmentDownload) {
      return (
        <div className="displayCell wsBoardAttachName">
          <a href={props.path} target="_blank">
            {props.attach_name}
          </a>
        </div>
      )
    } else {
      return (
        <div className="displayCell wsBoardAttachName">
          {props.attach_name}
        </div>
      )
    }
  }
}

const WsBoardAttachListComp = (props: AiAttachmentProps) => {
  return (
    <div className="wsBoardAttachDiv displayTable w100 tabLayFix">
      <div className="displayRow">
        <div
          className="displayCell wsBoardAttachTypeImg attachmentExtn"
          data-file-type={props.attachDet.file_extenstion}
        />
        {
          <RenderFileName
            key={props.attachDet.id}
            attach_name = {props.attachDet.attach_name}
            path = {props.attachDet.attach_link}
            fusStatus = {props.attachDet.fus_status}
            fusType = {props.attachDet.fus_type}
            isNoAttachmentDownload = {props.isNoAttachmentDownload}
          />
        }
        <div className="displayCell wsBoardAttachOwner">
          {props.attachDet.owner_name}
        </div>
        <div className="displayCell wsBoardAttachDueDiv">
          {props.attachDet.attach_time}
        </div>
        {props.ownerAccess && (
          <div
            className="displayCell wsBoardAttachCloseDiv clickable"
            data-perm-value={props.ownerAccess}
            onClick={() =>
              props.removeItemFromList(
                "aiAttachments",
                props.attachDet.id,
                props.ownerAccess
              )
            }
          >
            <ImgIconComp id="close" width="8" height="8" />
          </div>
        )}
      </div>
    </div>
  );
};